import { render, staticRenderFns } from "./CaseManagementCreate.vue?vue&type=template&id=72177a7c"
import script from "./CaseManagementCreate.vue?vue&type=script&lang=js"
export * from "./CaseManagementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports